import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import useTranslation from "../hooks/useTranslation";

import NavTab from "../components/NavTab";
import LiveCard from "../components/cards/Live";
import { Container } from "../layout/Container";
import CardsContainer from "../layout/CardsContainer";

const Tag = () => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(1);
  const { tagName } = useParams();
  const totalPosts = 0;

  const list = ["Live Channels", "Videos", "games"];
  return (
    <ContainerStyle>
      <header>
        <h2>#{tagName}</h2>
        <span>{totalPosts} {t('tag.posts')}</span>
      </header>
      <NavTab list={list} index={index} setIndex={setIndex} />
      {index === 1 && <LiveChannels tagName={tagName} />}
      {index === 2 && <Videos />}
      {index === 3 && <Games />}
    </ContainerStyle>
  );
};
export default Tag;

const LiveChannels = ({ tagName }) => {
  const [lives, setLives] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_STREAMS_ENDPOINT + "?tag=" + tagName, {
        withCredentials: true,
      })
      .then((res) => {
        setLives(res.data);
        console.log("=============> res.data");
        console.log(res.data);
      })
      .catch((err) => {});
  }, [tagName]);
  return lives.map((live, index) => {
    return (
      <LiveCard
        thumbnail={live?.thumbnail}
        tags={live?.tags}
        avatar={live?.avatar}
        verified={live?.verified}
        username={live?.username}
        gif={live?.thumbnailGif}
        title={live?.title}
        gamename={live?.stream_games?.name || live?.game?.name}
        gameid={live?.stream_games?.id || live?.game?._id}
        key={index}
        style={{ marginRight: "10px" }}
      />
    );
  });
};
const Videos = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_STREAMING_ENDPOINT + "videos", {
        withCredentials: true,
      })
      .then((res) => {
        setVideos(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  return <CardsContainer full cardsselection={videos} />;
};
const Games = () => {
  const [games, setGames] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_STREAMING_ENDPOINT + "games", {
        withCredentials: true,
      })
      .then((res) => {
        setGames(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  return <CardsContainer full cardsselection={games} />;
};
const ContainerStyle = styled(Container)`
  padding-top: 4rem;
  padding-bottom: 2rem;
  header {
    margin-bottom: 20px;
    h2 {
      color: ${({ theme }) => theme.color.primaryText};
      margin-bottom: 5px;
    }
    span {
      font-size: 15px;
      color: ${({ theme }) => theme.color.lighterText};
      font-family: "Poppins SemiBold";
    }
  }
`;
